const routes = [
  {
    path: '/mdfe/',
    name: 'mdfe',
    component: () => import('../views/MdfeView.vue'),
    redirect: { name: 'mdfe-listar' },
    children: [
      {
        path: 'welcome',
        name: 'mdfe-listar',
        component: () => import('../views/MdfeWelcomeView.vue'),
        meta: { title: 'MDF-e' },
      },
      {
        path: 'add',
        name: 'mdfe-cadastrar',
        component: () => import('../views/MdfeFormView.vue'),
        meta: { title: 'Novo MDF-e' },
      },
      {
        path: ':id',
        name: 'mdfe-editar',
        component: () => import('../views/MdfeFormView.vue'),
        meta: { title: 'Editar MDF-e' },
      },
    ],
  },
];

export default routes;
